export default __webpack_public_path__ + "783337e.png";